import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import { convertApiTimeToString } from "../../helpers/time/convertApiTime";
import { useTranslation } from "react-i18next";

const BillInfo = ({ bill, handlePayButtonClick }) => {
    const { t, i18n } = useTranslation();
    return (
		<div className="w-full">
			{/* Main part */}
			<div className="w-full flex justify-between">
				<div className="flex flex-col gap-1">
					<span>
						{t("bills.bill_info.bill")} № {bill.id}
					</span>
					<span className="font-bold">
						<NavLink to={`/shipments/${bill["shipment-id"] ?? ""}`}>
							{bill.trc}
						</NavLink>
					</span>
				</div>
				<div className="flex flex-col gap-1">
					<span>
						{convertApiTimeToString(
							bill["processed-at"],
							i18n.language
						)}
					</span>
					<span>
						{bill["end-weight"]
							? `${bill["end-weight"]?.toFixed(1)} kg`
							: ""}
					</span>
				</div>
				<div className="flex flex-col gap-1 font-bold">
					<span>{bill["end-price-usd"]}$</span>
					{!bill.paid && (
						<Button
							variant="contained"
							sx={{
								color: "white",
								bgcolor: "#059669",
								fontSize: "0.5rem",
								padding: "0.25rem 1rem",
								width: "90%",
								":hover": {
									bgcolor: "#047857",
								},
							}}
							onClick={handlePayButtonClick}
						>
							{t("bills.bill_info.pay")}
						</Button>
					)}
					{bill.paid && (
						<Button
							variant="contained"
							disabled={true}
							sx={{
								color: "white",
								bgcolor: "#059669",
								fontSize: "0.5rem",
								padding: "0.25rem 1rem",
								width: "90%",
								":hover": {
									bgcolor: "#047857",
								},
							}}
						>
							{t("bills.bill_info.paid")}
						</Button>
					)}
				</div>
			</div>
		</div>
    );
};

export default BillInfo;
